import {
  inject,
  Injectable,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { IPaymentProvider } from '@web/dtos';
import { AppConfigService } from '../../app-config.service';

@Injectable({
  providedIn: 'root',
})
export class MockPaymentProviderStore {
  private readonly configService: AppConfigService = inject(AppConfigService);

  readonly isLoading: Signal<boolean> = signal(false);
  readonly paymentProviders: WritableSignal<IPaymentProvider[]> = signal([]);

  getThumbnailPath(id: string | undefined): string {
    return this.configService.get().general.cmsUrl + '/paymentProviders/' + id;
  }

  buy() {}

  buyOnDemand() {}

  cancel() {}

  getPaymentMethods() {}

  addPaymentMethods() {}

  deletePaymentMethods(paymentMethodId: string) {}
}
